import Vue from 'vue';
import errorIcon from 'assets/icons/alert-bubble.svg';
export default Vue.extend({
    data() {
        return {
            errorIcon
        };
    },
    methods: {
        refresh() {
            window.location.reload();
        }
    }
});
